var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"lx-link",attrs:{"to":_vm.to}},'component',_vm.$attrs,false),[_vm._t("default"),(_vm.arrow)?_c('lx-icon',{staticClass:"arrow-icon",attrs:{"icon":"arrow-forward","size":"17,16"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }